/** Plain HTML preference controls — DevExtreme Switch/ButtonGroup can hit React #185 under React 19. */

export interface PrefSwitchProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  'aria-label'?: string;
}

export function PrefSwitch({ checked, disabled, onChange, 'aria-label': ariaLabel }: PrefSwitchProps) {
  return (
    <input
      type="checkbox"
      role="switch"
      className="pref-switch"
      checked={checked}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
}

export interface PrefSegmentItem<T extends string | number = string> {
  value: T;
  text: string;
}

export interface PrefSegmentedControlProps<T extends string | number = string> {
  items: PrefSegmentItem<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  'aria-label'?: string;
}

export function PrefSegmentedControl<T extends string | number = string>({
  items,
  value,
  onChange,
  className,
  'aria-label': ariaLabel
}: PrefSegmentedControlProps<T>) {
  return (
    <div
      className={['pref-segmented', className].filter(Boolean).join(' ')}
      role="group"
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <button
          key={String(item.value)}
          type="button"
          className={[
            'pref-segmented__btn',
            value === item.value ? 'pref-segmented__btn--selected' : ''
          ]
            .filter(Boolean)
            .join(' ')}
          aria-pressed={value === item.value}
          onClick={() => onChange(item.value)}
        >
          {item.text}
        </button>
      ))}
    </div>
  );
}
